import styled from 'styled-components';


export const Container = styled.div`
  z-index: 1;
  width: 100%;
  height: 100vh;
  padding-right: 50px;
  padding-left: 50px;
  
  background: linear-gradient(to right, #E71037, #ED933A);
  @media screen and (max-width: 991px) {
    width: 100%;
    height: 90vh;
  }

`;